// قطعات Zod مشترک؛ پیام‌ها کلید i18n هستند (FormFieldها آن را ترجمه می‌کنند).
import { z } from 'zod';
import { isValidNationalId, normalizeMobile, normalizeNationalId } from '../format/iranian';
import { normalizePersian } from '../format/normalize';

export const zRequiredText = (max = 200) =>
  z
    .string({ error: 'common:validation.required' })
    .transform((value) => normalizePersian(value))
    .pipe(
      z
        .string()
        .min(1, { error: 'common:validation.required' })
        .max(max, { error: 'common:validation.too_long' }),
    );

export const zMobile = () =>
  z
    .string({ error: 'common:validation.required' })
    .refine((value) => normalizeMobile(value) !== undefined, { error: 'common:validation.mobile' })
    .transform((value) => normalizeMobile(value) ?? value);

export const zNationalId = () =>
  z
    .string()
    .refine((value) => isValidNationalId(value), { error: 'common:validation.national_id' })
    .transform((value) => normalizeNationalId(value) ?? value);

/** مبلغ ریالی صحیح نامنفی (AmountMinor). */
export const zMoneyMinor = () =>
  z
    .number({ error: 'common:validation.required' })
    .int({ error: 'common:validation.money' })
    .nonnegative({ error: 'common:validation.money' });

/** تاریخ کسب‌وکاری yyyy-MM-dd. */
export const zBusinessDate = () =>
  z
    .string({ error: 'common:validation.required' })
    .regex(/^\d{4}-\d{2}-\d{2}$/, { error: 'common:validation.date' });
